import React, { useState, useEffect, useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { mixpanelEventTrack } from '../../services/mixpanel';
import '../../assets/styles/error.sass';
import validateValue from '../../utils/validateValue';

const NotesInput = ({ fieldKey }) => {
  const { key, inputMode, label, placeholder } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { rideId, driverNote = '', isWebBooker, step },
    updateDriverNote,
    updateEditor,
  } = context;

  const [value, setValue] = useState(driverNote);
  const [count, setCount] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    setCount(value?.length);
  }, [value]);

  const changeValueHandler = e => {
    const {
      target: { value },
    } = e;

    if (value.length > 30) {
      value.slice(0, 30);
      return false;
    }
    setValue(value);
  };

  const onBlur = () => {
    setTimeout(function () {
      updateDriverNote(value);
    }, 100);
  };

  const sendNoteToDriver = () => {
    mixpanelEventTrack(isWebBooker ? 'noteSendTappedWebBook' : 'noteSendTapped');

    return FetchService.getWebApiResource(urlService.sendNote(rideId, value.trim()))
      .then(() => {
        updateEditor('');
        updateDriverNote('');
      })
      .catch(() => {
        setError(true);
        updateDriverNote('');
      });
  };

  return (
    <div className={`form-group form-group-${key}${error === key ? ' error-group' : ''}`}>
      <div className="message-container">
        <label htmlFor={key} className={`form-label${!value ? ' hidden' : ''}`}>
          {label}
        </label>
        <input
          name={key}
          id={key}
          inputMode={inputMode}
          className={`form-input ${key}`}
          value={value}
          onChange={changeValueHandler}
          onBlur={onBlur}
          {...(placeholder && { placeholder: placeholder })}
        />
        <span className={`count ${isWebBooker ? 'web-count' : ''}`}>{count ? `${count}/` : ''}30</span>
        {error && <p className={'error'}>Sorry, an error occurred while sending message to driver.</p>}
      </div>

      {((isWebBooker && step !== 8) || !isWebBooker) && (
        <div className="buttons-container">
          <button className={`btn btn-default${count ? '' : ' disabled'}`} onClick={sendNoteToDriver}>
            Send
          </button>
        </div>
      )}
    </div>
  );
};

export default NotesInput;
